import DataSetService from '@/services/dataset.service';
import { DataSetState, RootState } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';

type DataSetGetter = GetterTree<DataSetState, RootState>;

export const initialState = (): DataSetState => {
  return {
    initialState,
    dataSets: [],
  };
};

export const getters: DataSetGetter = {
  dataSets: (state) => state,
  getDataSetById: (state) => (id: number) => state.dataSets.find((item) => item.id === Number(id)),

};

export const mutations: MutationTree<DataSetState> = {
  addDataSets(state, newDataSets) {
    state.dataSets = newDataSets;
  },
};

export const actions: ActionTree<DataSetState, RootState> = {
  async returnDataSetAsync(context: any, id: number) {
    const datasets = await DataSetService.getDataSets();
    context.commit('addDataSets', datasets);
    return datasets;
  },
};


export const dataSets: Module<DataSetState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
